import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { ProductTemplateRowActions } from 'modules/inventory/settings/product-templates/components/ProductTemplateRowActions';
import { IProductTemplate } from 'modules/inventory/settings/product-templates/interfaces';
import { PRODUCT_TEMPLATE_PERMISSIONS } from 'modules/inventory/settings/product-templates/constants/product-template.permissions';
import { createdATColumn } from 'modules/cms/testimony/constants';

export const productTemplateNameColumn: HeadCell<IProductTemplate> = {
  field: 'name',
  headerName: 'productTemplates:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IProductTemplate) => <EditLink entityId={data?._id as string}>{name}</EditLink>,
};

export const productTemplateFieldsColumn: HeadCell<IProductTemplate> = {
  field: 'fields',
  sortable: false,
  headerName: 'productTemplates:fields.fieldsCount',
  disablePadding: false,
  renderCell: (fields: IProductTemplate['fields']) => <span>{fields?.length ?? 0}</span>,
};

export const productTemplateActionsColumn: HeadCell<IProductTemplate> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: PRODUCT_TEMPLATE_PERMISSIONS.PRODUCT_TEMPLATE_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: ProductTemplateRowActions,
};

export const productTemplateColumns: Array<HeadCell<any>> = [
  productTemplateNameColumn,
  productTemplateFieldsColumn,
  createdATColumn,
  productTemplateActionsColumn,
];
